<template>
    <div>
        <v-app-bar color="primary"
                   dark
        >
            <router-link to="/">
            <img class="mr-3" :src="require('../../assets/images/logos/sedho.jpg')" height="20"/>
            </router-link>
       
            <v-menu
                    :offset-y="offsetY"
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            depressed
                            v-on="on"
                    >
                        {{ $t('menue.admin') }}
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item
                            v-for="item in sedhoM1"
                            :key="item.title"
                            :to="item.path"
                            color="primary"
                    >
                        <v-list-item-icon class="mr-3">
                            <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="text-left">{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
                    v-for="item in menuItemsRight"
                    :key="item.title"
                    :to="item.path"
                    icon
                    @click="handle(item.event)"
            >
                <v-icon>
                    {{item.icon}}
                </v-icon>
            </v-btn>
             <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                    color="primary"
                    dark
                    v-on="on"
                    >
                   {{ $t('language_choose') }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                    v-for="(lang, index) in languages"
                    :key="`lang${index}`"
                    v-on:click="cLanguage(lang)"
                    >
                    <v-list-item-title>{{ lang.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
    </div>
</template>

<script>
    export default {
        name: "TopNavi",
        data: (e) => ({
            title: 'sedho',
            sedhoM1: [
                {title: e.$t('submenu.user'), icon: 'mdi-sheep'},
            ],
            reports: [
                {title: 'Berichte Menüpunkt 1', icon: 'mdi-factory'}
            ],
            menuItemsRight: [
                {title: 'Activities', icon: 'mdi-checkbox-marked-outline', path: '/activities', event: ''},
                {title: 'Search', icon: 'mdi-magnify', event: ''},
                {title: 'Notifications', icon: 'mdi-login', path: '/Admin/LogIn', event: ''},
                {title: 'Settings', icon: 'mdi-settings'},
                {title: 'User', icon: 'mdi-logout', event: 'logout'}
            ],
            languages: [
                {title: e.$t('languages.english'), value: 'enEN'},
                {title: e.$t('languages.german'), value: 'deDE'}
            ],
            sidebar: false,
            appTitle: 'Robin Data ',
            disabled: false,
            absolute: false,
            openOnHover: false,
            value: false,
            closeOnClick: true,
            closeOnContentClick: true,
            offsetX: false,
            offsetY: true,
        }),
        methods: {
            handle(event){
                if (event) {
                    this[event]();
                }
            },
            logout () {
                this.submitted = true;
                const { dispatch } = this.$store;
                dispatch('authentification/logout', { });
            },
            cLanguage(lang) {
                this.$i18n.locale = lang.value;
                this.$store.dispatch('lang/setLanguage', lang.value);
            }
        }
    }
</script>

<style scoped>

</style>
